import { Selector } from '@ngxs/store';
import { PermissionContext } from 'src/app/shared/rpe/rpe-permissions.model';
import { UserEffectivePermissionsStateModel } from './user-effective-permissions.model';
import { UserEffectivePermissionsState } from './user-effective-permissions.state';

export class UserEffectivePermissionsSelectors {
  @Selector([UserEffectivePermissionsState])
  static state(
    state: UserEffectivePermissionsStateModel
  ): UserEffectivePermissionsStateModel {
    return state;
  }

  @Selector([UserEffectivePermissionsState])
  static permissionContexts(
    state: UserEffectivePermissionsStateModel
  ): PermissionContext[] {
    return state.permissionContexts;
  }

  @Selector([UserEffectivePermissionsState])
  static permissionsResolved(
    state: UserEffectivePermissionsStateModel
  ): boolean {
    return state.permissionsResolved;
  }

  @Selector([UserEffectivePermissionsState])
  static activeLocationId(
    state: UserEffectivePermissionsStateModel
  ): number | null {
    return state.activeLocationId;
  }

  @Selector([
    UserEffectivePermissionsState,
    UserEffectivePermissionsSelectors.activeLocationId,
  ])
  static activeContext(
    state: UserEffectivePermissionsStateModel,
    activeLocationId: number | null
  ): PermissionContext | undefined {
    if (activeLocationId == null) {
      return undefined;
    }
    const activeId = Number(activeLocationId);
    return state.permissionContexts.find(
      (ctx) => Number(ctx.locationId) === activeId
    );
  }
}
